<template>
    <div class="d-flex flex-row h-100 w-100">
        <p class="dv-title title-a">
            <slot></slot>
        </p>
        <p class="numbers p-2 bd-highlight">
            {{ value }}
        </p>
    </div>
</template>

<script>
export default {
    name: "KpiKeyValue",
    props: {
        value: String
    }
}
</script>

<style scoped>
.numbers {
    position: relative;
    overflow: hidden;
    border-radius: 0.375rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00ffc4;
    font-weight: 700;
    font-size: 1.5rem;
    margin: auto;
}

.dv-title.title-a {
    font-size: 1.2rem;
    color: white;
}
</style>